import React, { useState, useEffect } from 'react';
import { getLayout } from './storage';
import { ActionButtons } from '../App';

// ── 무인창고 홈화면 템플릿 ────────────────────────────────────
// template: 'storage' 테넌트에서 사용

export default function HomePageStorage({ tenant_name, onNavigate, onLogout, authInfo, API_BASE, token, tabs }) {
  const [showProfile, setShowProfile] = useState(false);
  const [showPwForm,  setShowPwForm]  = useState(false);
  const [pwCurrent,   setPwCurrent]   = useState('');
  const [pwNew,       setPwNew]       = useState('');
  const [pwMsg,       setPwMsg]       = useState('');
  const [units,       setUnits]       = useState([]);
  const [logs,        setLogs]        = useState([]);
  const [loading,     setLoading]     = useState(true);

  const authHeaders = () => ({
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  });

  useEffect(() => {
    fetchStatus();
    fetchLogs();
    const timer = setInterval(fetchStatus, 10000);
    return () => clearInterval(timer);
  }, []);

  const fetchStatus = async () => {
    try {
      const res  = await fetch(`${API_BASE}/api/storage/status`, { headers: authHeaders() });
      if (!res.ok) { setUnits(DUMMY_UNITS); return; }
      const data = await res.json();
      if (Array.isArray(data)) setUnits(data);
      else setUnits(DUMMY_UNITS);
    } catch { setUnits(DUMMY_UNITS); }
    finally { setLoading(false); }
  };

  const fetchLogs = async () => {
    try {
      const res  = await fetch(`${API_BASE}/api/storage/logs?limit=5`, { headers: authHeaders() });
      if (!res.ok) { setLogs(DUMMY_LOGS); return; }
      const data = await res.json();
      if (Array.isArray(data)) setLogs(data);
      else setLogs(DUMMY_LOGS);
    } catch { setLogs(DUMMY_LOGS); }
  };

  const layout      = getLayout(authInfo?.tenant_id);
  const layoutMeta  = layout.meta || { cols: 4, rows: 5 };
  const layoutCells = layout.cells || [];

  const mergedCells = layoutCells.map(cell => {
    if (cell.type !== 'unit') return cell;
    const live = units.find(u => u.unit_no === cell.unit_no);
    return { ...cell, ...(live || {}), is_occupied: live?.is_occupied || false };
  });

  const unitCells = mergedCells.filter(c => c.type === 'unit');
  const occupied  = unitCells.filter(u => u.is_occupied);
  const empty     = unitCells.filter(u => !u.is_occupied);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f3f0', fontFamily: '"Pretendard", sans-serif' }}>

      {/* 헤더 */}
      <div style={{ backgroundColor: '#2d1f0e', padding: '20px 20px 16px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
        <div style={{ maxWidth: '500px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '20px', fontWeight: '800', color: '#fff' }}>{tenant_name}</div>
            <div style={{ fontSize: '12px', color: '#d97706', marginTop: '2px' }}>📦 무인창고 관리 시스템</div>
          </div>
          <div style={{ position: 'relative' }}>
            <div onClick={() => { setShowProfile(!showProfile); setShowPwForm(false); setPwMsg(''); }}
              style={{ width: '36px', height: '36px', borderRadius: '50%', backgroundColor: '#92400e',
                       display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
              <span style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>
                {(authInfo?.username || '?')[0].toUpperCase()}
              </span>
            </div>
            {showProfile && (
              <div style={{ position: 'absolute', right: 0, top: '44px', backgroundColor: '#fff',
                            borderRadius: '14px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                            padding: '12px', zIndex: 100, minWidth: '200px' }}>
                <div style={{ paddingBottom: '10px', borderBottom: '1px solid #f3f4f6', marginBottom: '8px' }}>
                  <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#111827' }}>{authInfo?.username}</div>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>{tenant_name}</div>
                </div>
                <button onClick={() => { setShowPwForm(!showPwForm); setPwMsg(''); setPwCurrent(''); setPwNew(''); }}
                  style={{ width: '100%', padding: '7px 10px', background: 'none', border: 'none',
                           cursor: 'pointer', fontSize: '12px', color: '#92400e', textAlign: 'left', borderRadius: '8px' }}>
                  🔑 비밀번호 변경
                </button>
                {showPwForm && (
                  <div style={{ marginTop: '6px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <input type="password" placeholder="현재 비밀번호" value={pwCurrent}
                      onChange={e => setPwCurrent(e.target.value)}
                      style={{ padding: '8px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '12px', outline: 'none' }} />
                    <input type="password" placeholder="새 비밀번호" value={pwNew}
                      onChange={e => setPwNew(e.target.value)}
                      style={{ padding: '8px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '12px', outline: 'none' }} />
                    {pwMsg && <div style={{ fontSize: '11px', color: pwMsg.startsWith('✅') ? '#16a34a' : '#dc2626' }}>{pwMsg}</div>}
                    <button onClick={async () => {
                      if (!pwCurrent || !pwNew) { setPwMsg('❌ 모두 입력하세요'); return; }
                      try {
                        const res = await fetch(`${API_BASE}/api/auth/change-password`, {
                          method: 'POST', headers: authHeaders(),
                          body: JSON.stringify({ current_password: pwCurrent, new_password: pwNew }),
                        });
                        if (res.ok) { setPwMsg('✅ 변경 완료'); setPwCurrent(''); setPwNew(''); }
                        else { const d = await res.json(); setPwMsg('❌ ' + (d.detail || '변경 실패')); }
                      } catch { setPwMsg('❌ 서버 오류'); }
                    }}
                      style={{ padding: '8px', backgroundColor: '#92400e', color: '#fff', border: 'none',
                               borderRadius: '8px', fontSize: '12px', cursor: 'pointer', fontWeight: 'bold' }}>
                      변경
                    </button>
                  </div>
                )}
                <div style={{ borderTop: '1px solid #f3f4f6', marginTop: '8px', paddingTop: '8px' }}>
                  <button onClick={onLogout}
                    style={{ width: '100%', padding: '7px 10px', background: 'none', border: 'none',
                             cursor: 'pointer', fontSize: '12px', color: '#ef4444', fontWeight: 'bold', textAlign: 'left', borderRadius: '8px' }}>
                    🚪 로그아웃
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '500px', margin: '0 auto', padding: '16px' }}>

        {/* 요약 카드 */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
          <div style={{ flex: 1, backgroundColor: '#fff', borderRadius: '14px', padding: '16px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center' }}>
            <div style={{ fontSize: '28px', fontWeight: '900', color: '#10b981' }}>{empty.length}</div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>빈 창고</div>
          </div>
          <div style={{ flex: 1, backgroundColor: '#fff', borderRadius: '14px', padding: '16px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center' }}>
            <div style={{ fontSize: '28px', fontWeight: '900', color: '#ef4444' }}>{occupied.length}</div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>사용중</div>
          </div>
          <div style={{ flex: 1, backgroundColor: '#fff', borderRadius: '14px', padding: '16px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center' }}>
            <div style={{ fontSize: '28px', fontWeight: '900', color: '#2d1f0e' }}>{unitCells.length}</div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>전체</div>
          </div>
        </div>

        {/* 창고 맵 */}
        <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '16px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
            <div style={{ fontWeight: '700', fontSize: '15px', color: '#111827' }}>🗺 창고 지도</div>
            <div style={{ display: 'flex', gap: '10px', fontSize: '11px', color: '#6b7280' }}>
              <span>🟢 빈창고</span>
              <span>🔴 사용중</span>
            </div>
          </div>

          <div style={{ maxHeight: '28vh', overflowY: 'auto', overflowX: 'hidden' }}>
          {(() => {
            const c = layoutMeta.cols || 4;
            const colTypes = Array.from({ length: c }, (_, ci) => {
              const hasUnit = layoutCells.some(cell => cell.col === ci && cell.type === 'unit');
              return hasUnit ? '1fr' : '20px';
            });
            return (
            <div style={{
              display: 'grid',
              gridTemplateColumns: colTypes.join(' '),
              gap: '4px',
              width: '100%',
            }}>
            {mergedCells.map((cell, i) => {
              if (cell.type === 'unit') return <UnitCard key={i} unit={cell} />;
              if (cell.type === 'aisle') return (
                <div key={i} style={{ backgroundColor: '#f3f4f6', borderRadius: '4px', width: '100%', height: '40px' }} />
              );
              if (cell.type === 'pillar') return (
                <div key={i} style={{ width: '100%', height: '10px', backgroundColor: '#6b7280', borderRadius: '3px' }} />
              );
              if (cell.type === 'wall') return (
                <div key={i} style={{ backgroundColor: '#374151', borderRadius: '4px', width: '100%', height: '40px' }} />
              );
              if (cell.type === 'entrance') return (
                <div key={i} style={{ backgroundColor: '#fef3c7', borderRadius: '4px', border: '1px solid #d97706',
                                      width: '100%', height: '40px',
                                      display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ fontSize: '9px', fontWeight: '700', color: '#92400e' }}>출입구</span>
                </div>
              );
              return <div key={i} style={{ width: '100%', height: '40px' }} />;
            })}
            </div>
            );
          })()}
          </div>
        </div>

        {/* 최근 입/출고 로그 */}
        <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '12px 16px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <div style={{ fontWeight: '700', fontSize: '13px', color: '#111827' }}>📋 최근 입/출고</div>
            <button onClick={fetchLogs}
              style={{ fontSize: '10px', color: '#92400e', background: 'none', border: 'none', cursor: 'pointer' }}>
              새로고침
            </button>
          </div>
          {logs.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#9ca3af', fontSize: '11px', padding: '8px' }}>기록 없음</div>
          ) : (
            <div
              style={{ height: '60px', overflowY: 'auto', position: 'relative' }}
              onMouseEnter={e => e.currentTarget.querySelector('.scroll-inner-s').style.animationPlayState = 'paused'}
              onMouseLeave={e => e.currentTarget.querySelector('.scroll-inner-s').style.animationPlayState = 'running'}
              onTouchStart={e => e.currentTarget.querySelector('.scroll-inner-s').style.animationPlayState = 'paused'}
              onTouchEnd={e => e.currentTarget.querySelector('.scroll-inner-s').style.animationPlayState = 'running'}
            >
              <style>{`
                @keyframes scrollUpS {
                  0% { transform: translateY(0); }
                  100% { transform: translateY(-50%); }
                }
              `}</style>
              <div className="scroll-inner-s" style={{
                animation: `scrollUpS ${logs.length * 2}s linear infinite`,
                display: 'flex', flexDirection: 'column', gap: '4px',
              }}>
                {[...logs, ...logs].map((log, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '3px 0' }}>
                    <span style={{ fontSize: '10px' }}>{log.type === 'in' ? '🟢' : '🔴'}</span>
                    <span style={{ fontSize: '11px', fontWeight: '700', color: '#111827' }}>{log.unit_no}</span>
                    <span style={{ fontSize: '10px', color: '#6b7280' }}>{log.user_name}</span>
                    <span style={{ fontSize: '10px', color: log.type === 'in' ? '#10b981' : '#ef4444', fontWeight: '600' }}>
                      {log.type === 'in' ? '입고' : '출고'}
                    </span>
                    <span style={{ fontSize: '10px', color: '#9ca3af', marginLeft: 'auto' }}>{log.time}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* 공통 액션 버튼 */}
        <ActionButtons token={token} tabs={tabs} onNavigate={onNavigate} API_BASE={API_BASE} template='storage' />

      </div>
    </div>
  );
}

// ── 창고 칸 카드 ──────────────────────────────────────────────
function UnitCard({ unit }) {
  const [showDetail, setShowDetail] = useState(false);

  return (
    <div onClick={() => unit.is_occupied && setShowDetail(!showDetail)}
      style={{ backgroundColor: unit.is_occupied ? '#fef2f2' : '#f0fdf4',
               borderRadius: '8px', padding: '4px',
               border: `2px solid ${unit.is_occupied ? '#fca5a5' : '#86efac'}`,
               width: '100%', height: '40px',
               cursor: unit.is_occupied ? 'pointer' : 'default',
               display: 'flex', flexDirection: 'column',
               alignItems: 'center', justifyContent: 'center',
               overflow: 'hidden' }}>
      <div style={{ fontSize: '8px', fontWeight: '700',
                    color: unit.is_occupied ? '#dc2626' : '#16a34a',
                    textAlign: 'center', lineHeight: '1.2' }}>
        {unit.unit_no || '?'}
      </div>
      {unit.is_occupied && unit.user_name && (
        <div style={{ fontSize: '7px', color: '#6b7280', marginTop: '1px', fontWeight: '600' }}>
          {unit.user_name}
        </div>
      )}
      {showDetail && unit.is_occupied && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 10,
                      backgroundColor: '#fff', borderRadius: '6px', padding: '6px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)', fontSize: '10px', color: '#374151' }}>
          <div>창고: {unit.unit_no}</div>
          <div>고객: {unit.user_name}</div>
          {unit.expiry_date && <div>만료: {unit.expiry_date}</div>}
        </div>
      )}
    </div>
  );
}

// ── 더미 데이터 ───────────────────────────────────────────────
const DUMMY_UNITS = [
  { unit_no: 'A01', is_occupied: true,  user_name: '홍길동', expiry_date: '2026-06-30' },
  { unit_no: 'A02', is_occupied: false },
  { unit_no: 'A03', is_occupied: true,  user_name: '김철수', expiry_date: '2026-12-31' },
  { unit_no: 'A04', is_occupied: false },
  { unit_no: 'B01', is_occupied: false },
  { unit_no: 'B02', is_occupied: true,  user_name: '이영희', expiry_date: '2026-09-30' },
  { unit_no: 'B03', is_occupied: false },
  { unit_no: 'B04', is_occupied: true,  user_name: '박민수', expiry_date: '2026-03-31' },
];

const DUMMY_LOGS = [
  { unit_no: 'A01', user_name: '홍길동', type: 'in',  time: '09:15' },
  { unit_no: 'B02', user_name: '이영희', type: 'out', time: '10:30' },
  { unit_no: 'A03', user_name: '김철수', type: 'in',  time: '11:00' },
  { unit_no: 'B04', user_name: '박민수', type: 'out', time: '13:20' },
];
